var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.showNoDiagnoseFoundModal)?_c('div',{attrs:{"id":"outer"}},[_c('div',{attrs:{"id":"left-uebersicht"}},[_c('UebersichtEingaben')],1),_c('VorgeschlageneDiagnoseComponent',{attrs:{"id":"vorgeschlagene-diagnose"}}),_c('DiagnoseAuswahl',{attrs:{"id":"diagnose-auswahl"}})],1):_c('div')
}
var staticRenderFns = []

export { render, staticRenderFns }